/** The handle of every webhooks toast, the one the screens' notice had. */
export const WEBHOOKS_NOTICE = 'webhooks-notice';

/**
 * The toasts of the seller's webhooks. A toast outlives the page, which is what
 * lets a deletion from the detail still be announced on the listing it goes
 * back to. See `feedbackCatalog` for what each field means.
 */
export const WEBHOOKS_FEEDBACK_RULES = {
  'webhooks/createWebhook': { success: 'Webhook creado', testId: WEBHOOKS_NOTICE },
  'webhooks/updateWebhook': { success: 'Webhook actualizado', testId: WEBHOOKS_NOTICE },
  'webhooks/deleteWebhook': { success: 'Webhook eliminado', testId: WEBHOOKS_NOTICE },
};
